<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="notification-preview__header">
    <button class="common-button__text-noborder"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'notification-preview.close'">Cerrar vista previa</span>
      <i class="lf-icon-close-round common-icon__md"></i>
    </button>
  </div>
  <!-- Contenedor -->
  @if (notificationPreview.html) {
    <div class="notification-preview__container-notification"
      [innerHTML]="notificationPreview.html"></div>
  }
</div>

